import React from 'react';
import { Icon } from '@fuxi/eevee-icon';
import { DeviceStatePhoto, MachineState } from '@/constant';
import { isShowMachineLockState } from '@/pages/device/device-management';
import CheckRight from '@/assets/icon/CheckRight.svg';
import cx from './index.module.scss';

interface Props {
  machineList: DeviceItem[];
  selectMachineIndex: number;
  handleClickMachineItem: (item: DeviceItem, index: number) => () => void;
}

const MachineCards = ({ handleClickMachineItem, machineList, selectMachineIndex }: Props) => {
  return (
    <div className={cx('machine-list')} id="machine-list">
      {machineList?.map((item, index) => (
        <div
          className={cx('machine-item', isShowMachineLockState(item) ? 'idle' : item.state?.toLowerCase(), {
            active: selectMachineIndex === index,
          })}
          key={item.deviceId}
          onClick={handleClickMachineItem(item, index)}
        >
          <div className={cx('machine-info')}>
            <div
              className={cx('machine-box-bottom', {
                'is-manual-only': item?.state === 'ManualOnly' && item.controlState !== 'lock',
              })}
            >
              <div className={cx('machine-name')}>{item.deviceName}</div>
              <div className={cx('machine-id')}>{item.deviceId}</div>
              <div className={cx('state')}>{isShowMachineLockState(item) ? '已锁机' : MachineState[item.state]}</div>
              {!!item?.errorMessage && item?.controlState !== 'lock' && (
                <div className={cx('recover-tips')}>
                  <Icon className={cx('icon')} name="info-circle" />
                  <span>{item.errorMessage}</span>
                </div>
              )}
            </div>
          </div>

          <div className={cx('machine-bg-wrapper')}>
            <div
              className={cx('machine-bg')}
              style={{
                backgroundImage: `url(${DeviceStatePhoto[item.state === 'Busy' ? 'online' : 'offline']})`,
              }}
            />
          </div>
          <div className={cx('mirror-shadow-bg')} />
          {selectMachineIndex === index && (
            <div className={cx('bottom-box')}>
              <span className={cx('text')}>已选择</span>
              <img className={cx('checkbox-right')} alt="checkbox" src={CheckRight}></img>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default React.memo(MachineCards);
